import './search-home.css';
const SearchModal = () => {
    return (
        <>
        </>
    );
};
export default SearchModal;
